import FormattedMessage from 'I18n/components/FormattedMessage';
import Products from 'merchandise-lib/constants/Product';
import { useTierQueryParam } from '../../../hooks/useTierQueryParam';
import PricingPlanToggleButton from '../../components/PricingPlanToggleButton';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { StarterLowerTierMessage } from '../../containers/merch-card/StarterLowerTierMessage';
import { SCREENS } from '../../constants/tracking/Screens';
import { useTabAwareProductsConfig } from '../../hooks/utilities/useTabAwareProductsConfig';
import { useIsInAppAuth } from '../../hooks/user/useUserInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const productsConfig = {
  STARTER: {
    apiName: Products.SERVICE_HUB_STARTER,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.service.starterCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(StarterLowerTierMessage, {})
  },
  PROFESSIONAL: {
    apiName: Products.SERVICE_HUB_PROFESSIONAL,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.service.professionalCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.service.professional.lowerTierPlus"
    })
  },
  ENTERPRISE: {
    apiName: Products.SERVICE_HUB_ENTERPRISE,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.service.enterpriseCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.service.enterprise.lowerTierPlus"
    })
  }
};
export const ServiceHubMerchCards = () => {
  const filteredProductsConfig = useTabAwareProductsConfig(productsConfig);
  const tier = useTierQueryParam();
  const isAppAuth = useIsInAppAuth();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
      productsConfig: filteredProductsConfig,
      screen: SCREENS.SERVICE
    }), !isAppAuth && /*#__PURE__*/_jsx(PricingPlanToggleButton, {
      tier: tier
    })]
  });
};